import {provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage} from 'ngx-webstorage';
import {HttpClient, HttpErrorResponse, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import {httpInterceptorProviders} from './core/http-interceptors';
import {MatchHeightModule} from './shared/directives/match-height.directive';
import {AppRoutingModule} from './app-routing.module';
import {BrowserModule, Title} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injectable, NgModule, provideZoneChangeDetection} from '@angular/core';
import {AppComponent} from './app.component';
import {CoreModule} from './core/core.module';
import {ToolsService} from './shared/services/tools/tools.service';
import {FieldTypesService} from './shared/services/tools/field-types.service';
import {HydraService} from './core/services/hydra.service';
import {AuthGuard} from './core/guards/auth.guard';
import {IsAdminGuard} from './core/guards/is-admin.guard';
import {IsCandidatGuard} from './core/guards/is-candidat.guard';
import {IsExpertGuard} from './core/guards/is-expert.guard';
import {IsPresidentGuard} from './core/guards/is-president.guard';
import {IsDatavisOrAdminGuard} from './core/guards/is-datavis-or-admin.guard';
import {IsPresidentOrMoreGuard} from './core/guards/is-president-or-more.guard';
import {AuthentificationService} from './core/services/authentification.service';
import {LoaderService} from './core/services/loader.service';
import {MaterialImportsModule} from './material-imports/material-imports.module';
import {FieldValueManagerService} from './modules/dossiers/formulaire-saisie/field-value-manager.service';
import {
    ToggleAdministrableService
} from './modules/aides-configs/aides-formulaire-block/aides-formulaire-block.service';
import {TranslateLoader, TranslateModule, TranslateService,} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {LocalisationService} from './shared/components/localisations/localisation.service';
import {ProfilManagerService} from './modules/profil/profil-manager.service';
import {SubscribeService} from './core/services/subscribe.service';


import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import {DatePipe, registerLocaleData} from '@angular/common';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
// moment n'embarque que la locale 'en' : sans cet import, les datepickers affichent le format anglais même en français
import 'moment/locale/fr';
import moment from 'moment';
import {SharedModule} from './shared/shared.module';
import * as Sentry from '@sentry/browser';

import {environment} from '../environments/environment';
import {VersionCheckService} from './core/services/version-check.service';
import {IsExpertOrMoreGuard} from './core/guards/is-expert-or-more.guard';
import {IsPartnerGuard} from './core/guards/is-partner.guard';
import {StringService} from './core/services/string.service';
import {SearchService} from './core/services/search.service';
import {MaintenanceCheckService} from './core/services/maintenance-check.service';
import {QuillModule} from 'ngx-quill';
import {CanAccessAdministrationModuleGuard} from "./core/guards/can-access-administration-module.guard";
import {CanAccessDatavisModuleGuard} from "./core/guards/can-access-datavis-module.guard";
import {MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS} from "@angular/material/progress-spinner";


// @todo : gros PB ici, car dans app.component.ts on a un traitement différent...
let localeDefault = window.localStorage.getItem('langue');
if (!localeDefault) {
    localeDefault = 'fr';
}
registerLocaleData(localeFr, localeDefault, localeFrExtra);

//on a également besoin de la locale FR pour certains éléments (dont currency)
if (localeDefault !== 'fr') {
    registerLocaleData(localeFr, 'fr', localeFrExtra);
}

// Les datepickers utilisent le format moment 'l', que moment déduit de 'L' en retirant les zéros (5/9/2026).
// En français on garde les zéros (05/09/2026) ; l'anglais reste sans zéro (9/5/2026), conformément à l'usage.
moment.updateLocale('fr', {longDateFormat: {l: 'DD/MM/YYYY'} as moment.LongDateFormatSpec});

if (environment.sentryDsn.length > 0) {
    Sentry.init({
        environment: environment.sentryEnvironment,
        dsn: environment.sentryDsn,
        release: environment.versionID,
        ignoreErrors: ['ResizeObserver loop limit exceeded']
    });
}

if (environment.production) {
    console.log('VERSION >> ', environment.versionID);
}

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
    constructor() {
    }

    handleError(error) {

        const chunkErrorFingerPrint = 'Error: Loading chunk';

        if (error
            && error['rejection']
            && error.rejection['message']
            && error.rejection['message'].indexOf(chunkErrorFingerPrint) !== -1
        ) {
            window.location.reload();
            return;
        }

        if (error['originalStack'] && error.originalStack.indexOf(chunkErrorFingerPrint) !== -1) {
            window.location.reload();
            return;
        }

        if (error['message'] && error['message'].indexOf(chunkErrorFingerPrint) !== -1) {
            window.location.reload();
            return;
        }

        if (environment.sentryDsn.length === 0) {
            console.error(error);
            return;
        }

        if (error instanceof HttpErrorResponse) {
            Sentry.withScope(scope => {
                const urlContextFingerPrint = window.location.pathname.replace(/[0-9]/g, '');
                let urlApiFingerPrint = error.url;

                const startUrlApi = urlApiFingerPrint.indexOf('/api/');
                const endUrlApi = urlApiFingerPrint.indexOf('?');

                if (endUrlApi !== -1) {
                    urlApiFingerPrint = urlApiFingerPrint.substr(
                        startUrlApi,
                        endUrlApi - startUrlApi
                    );
                } else {
                    urlApiFingerPrint = urlApiFingerPrint.substr(
                        startUrlApi
                    );
                }

                urlApiFingerPrint = urlApiFingerPrint
                    .replace(/[0-9]/g, '')
                    .replace('//', '');

                scope.setFingerprint([urlContextFingerPrint, urlApiFingerPrint]);
                scope.setTag('status', error.status + '');

                if (error && error['statusText'] && urlApiFingerPrint) {
                    Sentry.captureException(new Error(error.statusText + ' : ' + urlApiFingerPrint));
                }

            });
        } else {
            Sentry.captureException(error.originalError || error);
        }

        // const eventId = Sentry.captureException(error.originalError || error);
        // Sentry.showReportDialog({ eventId });
    }
}

// TRADUCTION

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

@NgModule(
    {
        declarations: [
            AppComponent
        ],
        schemas: [CUSTOM_ELEMENTS_SCHEMA],
        bootstrap: [AppComponent], imports: [BrowserModule,
            NoopAnimationsModule,
            CoreModule,
            AppRoutingModule,
            MatchHeightModule,
            MaterialImportsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
            MatMomentDateModule,
            SharedModule,
            QuillModule.forRoot()],
        providers: [
            provideNgxWebstorage(
                withNgxWebstorageConfig({separator: ':', caseSensitive: true}),
                withLocalStorage(),
                withSessionStorage()),
            ToolsService,
            StringService,
            SearchService,
            LoaderService,
            ToggleAdministrableService,
            HydraService,
            FieldTypesService,
            AuthentificationService,
            AuthGuard,
            IsAdminGuard,
            IsCandidatGuard,
            IsExpertGuard,
            IsExpertOrMoreGuard,
            IsPresidentGuard,
            IsPresidentOrMoreGuard,
            IsDatavisOrAdminGuard,
            IsPartnerGuard,
            CanAccessAdministrationModuleGuard,
            CanAccessDatavisModuleGuard,
            FieldValueManagerService,
            LocalisationService,
            ProfilManagerService,
            TranslateService,
            SubscribeService,
            httpInterceptorProviders,
            {provide: ErrorHandler, useClass: SentryErrorHandler},
            {provide: MAT_DATE_LOCALE, useValue: localeDefault},
            {
                provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
                useValue: {
                    _forceAnimations: true
                }
            },
            VersionCheckService,
            MaintenanceCheckService,
            DatePipe,
            Title,
            provideHttpClient(withInterceptorsFromDi()),
            provideZoneChangeDetection()
        ]
    })
export class AppModule {
}
